import React from 'react';

export default function AdminTrans() {
    return (
        <div>
            <h1>AdminTrans</h1>
        </div>
    );
}